<template>
  <v-app>
    <Appbar />
    <v-main>
      <Information />
      <v-row
        class="ma-0 pa-0 flex-nowrap"
        style="height:100%;"
      >
        <v-list
          v-if="!hideMenu"
          :style="`background-color: ${backgroundColor};`"
          class="pa-0 ma-0 left-nav "
          max-width="240px"
          min-width="240px"
          width="240"
        >
          <v-list-item
            :style="`background-color:${listBgColor};`"
            :to="{name:'NovelPlot', params: { novelid: encodeHash(novelId) }}"
            active-class="secondary highlighted"
            class="left-nav-item"
          >
            <v-list-item-content>
              <v-list-item-title class="nav-text">
                プロット
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :style="`background-color:${listBgColor};`"
            :to="{name:'NovelTheme', params: { novelid: encodeHash(novelId) }}"
            active-class="secondary highlighted"
            class="left-nav-item"
          >
            <v-list-item-content>
              <v-list-item-title class="nav-text">
                テーマ
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :exact="currentPageIndex !== 2"
            :style="`background-color:${listBgColor};`"
            :to="{name:'NovelIndex', params: { novelid: encodeHash(novelId) }}"
            active-class="secondary highlighted"
            class="left-nav-item"
          >
            <v-list-item-content>
              <v-list-item-title class="nav-text">
                本文
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :style="`background-color:${listBgColor};`"
            :to="{name:'NovelDocument', params: { novelid: encodeHash(novelId) }}"
            active-class="secondary highlighted"
            class="left-nav-item"
          >
            <v-list-item-content>
              <v-list-item-title class="nav-text">
                資料
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-spacer />

          <v-list-item>
            <v-list-item-content class="mt-4 d-flex justify-center">
              <v-btn
                color="secondary"
                elevation="0"
                height="30px"
                class="savebutton-pc"
                outlined
                width="150px"
                @click="hideAppbar=!hideAppbar"
              >
                {{ `画面ワイドモード：${hideAppbar ? 'ON' : 'OFF'}` }}
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="mt-2 d-flex justify-center">
              <v-btn
                color="secondary"
                elevation="0"
                height="30px"
                class="savebutton-pc"
                outlined
                width="150px"
                :to="{ name: 'NovelEdit', params: { novelid: encodeHash(novelId) }}"
              >
                小説編集画面を開く
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-spacer />
        </v-list>
        <div>
          <div
            class="left-nav "
            @click="hideMenu=!hideMenu"
          >
            <div
              class="menu-toggle justify-center d-flex align-center py-1 pr-1 "
            >
              <v-img
                v-if="hideMenu"
                src="../assets/arrow_right.png"
              />
              <v-img
                v-else-if="!hideMenu"
                src="../assets/arrow_left.png"
              />
            </div>
          </div>
        </div>
        <div
          class="pa-0 ma-0"
          style="width: 100%"
        >
          <!--<v-row no-gutters>-->
          <!--<v-col>-->

          <router-view />

          <!--</v-col>-->
          <!--<v-col  cols="12" sm="12" md="3" lg="3" xl="3" style="background-color: #666666">-->
          <!--広告入れるエリア-->
          <!--<Adsense-->
          <!--data-ad-client="ca-pub-5152865430457107"-->
          <!--data-ad-slot="8539426925">-->
          <!--</Adsense>-->
          <!--</v-col>-->
          <!--</v-row>-->
        </div>
      </v-row>
    </v-main>

    <div class="bottom-bar-nav">
      <v-bottom-navigation :style="`background-color:${listBgColor};`">
        <v-btn :to="{name:'NovelPlot', params: { novelid: encodeHash(novelId) }}">
          <span :class="`nav-text-${currentPageIndex==0 ? 'bottom-selected':'bottom'}`">プロット</span>
        </v-btn>

        <v-btn :to="{name:'NovelTheme', params: { novelid: encodeHash(novelId) }}">
          <span :class="`nav-text-${currentPageIndex==1 ? 'bottom-selected':'bottom'}`">テーマ</span>
        </v-btn>

        <v-btn
          :to="{name:'NovelIndex', params: { novelid: encodeHash(novelId) }}"
          two-line
        >
          <span :class="`nav-text-${currentPageIndex==2 ? 'bottom-selected':'bottom'}`">本文</span>
        </v-btn>

        <v-btn
          :to="{name:'NovelDocument', params: { novelid: encodeHash(novelId) }}"
          two-line
        >
          <span :class="`nav-text-${currentPageIndex==3 ? 'bottom-selected':'bottom'}`">資料</span>
        </v-btn>
      </v-bottom-navigation>
    </div>
    <Footer
      :accent-color="accentColor"
      :sub-primary-color="subPrimaryColor"
    />
  </v-app>
</template>

<script>
import firebase from "firebase/app"
import Footer from '../component/Footer.vue';
import Appbar from '../component/Appbar.vue';
import Information from '../component/Information.vue';
import config from "@/const";

export default {
  name: "NovelVue",
  components: {
    Footer,
    Appbar,
    Information
  },
  data() {
    return {
      drawer: null,
      novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
      accentColor: null,
      subPrimaryColor: null,
      backgroundColor: null,
      listBgColor: null,
      currentPageIndex: 2,
      hideAppbar: false,
      hideMenu: false
    }
  },
  watch: {
    $route: {
      handler: async function () {
        this.novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]

        if (this.$route.path.match("plots")) {
          this.currentPageIndex = 0
        } else if (this.$route.path.match("themes")) {
          this.currentPageIndex = 1
        } else if (this.$route.path.match("documents")) {
          this.currentPageIndex = 3
        } else {
          this.currentPageIndex = 2
        }
      },
      immediate: true
    },
    hideAppbar(newValue) {
      this.$store.commit("userModule/setHideAppbar", newValue)
    },
    hideMenu(newValue) {
      this.$store.commit("userModule/setHideMenu", newValue)
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    const primary = this.$vuetify.theme.themes.light.primary
    const red = parseInt(primary.substring(1, 3), 16);
    const green = parseInt(primary.substring(3, 5), 16);
    const blue = parseInt(primary.substring(5, 7), 16);

    const accentRed = parseInt(this.accentColor.substring(1, 3), 16);
    const accentGreen = parseInt(this.accentColor.substring(3, 5), 16);
    const accentBlue = parseInt(this.accentColor.substring(5, 7), 16);

    this.backgroundColor = primary
    this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
    this.listBgColor = "#" + Math.floor((red * 0.9) + (accentRed * 0.1)).toString(16).padStart(2, '0')
        + Math.floor((green * 0.9) + (accentGreen * 0.1)).toString(16).padStart(2, '0')
        + Math.floor((blue * 0.9) + (accentBlue * 0.1)).toString(16).padStart(2, '0')

    this.hideAppbar = this.$store.state.userModule.hideTopBottomMode
  },

  methods: {
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    loguout() {
      firebase.auth().signOut();
    },
  }
}
</script>

<style scoped>
.bottom-bar-nav {
  position: fixed;
  width: 100%;
  bottom: 0;
}

.nav-text {
  color: white;
  font-size: 14px;
  margin-left: 22px;
  font-weight: bold;
}

.nav-text-bottom {
  color: white;
  font-size: 14px;
}

.nav-text-bottom-selected {
  color: var(--v-secondary-base);
  font-size: 14px;
}

.left-nav-item {
  height: 60px;
}

.left-nav-item:active {
  background-color: var(--v-secondary-base);
}

.highlighted {
  color: var(--v-secondary-base);
  color: white;
  font-size: 14px;
  font-weight: bold;
}

/* 画面サイズの横幅が 768px より大きい場合に適用 */
@media screen and (min-width: 960px) {
  .bottom-bar-nav {
    display: none;
  }

  .left-nav {
    display: block;
  }
}

/* 画面サイズの横幅が小さい場合に適用 */
@media screen and (max-width: 960px) {
  .bottom-bar-nav {
    display: block;
  }

  .left-nav {
    display: none;
  }
}

.savebutton-pc {
  padding-top: 1px !important;
  border: solid 2px var(--v-secondary-base) !important;
  border-radius: 5px;
  background-color: var(--v-primary-base) !important;
  font-weight: bold !important;
  font-size: 13px !important;
  color: white !important;
}

.menu-toggle {
  background-color: var(--v-secondary-base) !important;
  /* 右下のみ角丸 */
  border-bottom-right-radius: 6px;
  -webkit-border-bottom-right-radius: 6px;
  -moz-border-radius-bottomright: 6px;

  /* 右上のみ角丸 */
  border-top-right-radius: 6px;
  -webkit-border-top-right-radius: 6px;
  -moz-border-radius-topright: 6px;
  width: 30px;
  height: 40px;
  margin-top: 5px;
}
</style>
